import { useQuery } from "@apollo/client";
import { Box } from "@mui/material";
import { ReactElement } from "react";

import { GetTenantExportConfigsQuery } from "~frontend/__generated__/graphql";
import ErrorCard from "~frontend/components/ErrorCard";
import Loading from "~frontend/components/Loading";
import PageContainer from "~frontend/components/PageContainer";
import { PageHeader } from "~frontend/components/PageHeader";
import { GET_TENANT_EXPORT_CONFIGS } from "~frontend/graphql/tenantExportConfigs";
import { useBreadcrumbs } from "~frontend/providers/BreadcrumbsProvider";

import BigQueryTenantExportConfig from "./BigqueryTenantExportConfig";
import S3TenantExportConfig from "./S3TenantExportConfig";

export default function OrgExports(): ReactElement {
  useBreadcrumbs([
    {
      label: "Data Exports",
      path: "/organization/exports",
    },
  ]);

  const { loading, error, data } = useQuery<GetTenantExportConfigsQuery>(
    GET_TENANT_EXPORT_CONFIGS
  );

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorCard errors={[error]} />;
  }
  return (
    <PageContainer>
      <PageHeader>Data Exports</PageHeader>
      <Box sx={{ marginBottom: 4 }}>
        <S3TenantExportConfig
          exportConfig={data!.tenantExportConfigs.s3ExportConfig}
        />
      </Box>
      <Box sx={{ marginBottom: 4 }}>
        <BigQueryTenantExportConfig
          exportConfig={data!.tenantExportConfigs.bigqueryExportConfig}
        />
      </Box>
    </PageContainer>
  );
}
